<template>
  <form class="hito-vida-form form-horizontal" @submit.prevent="submit()">
    <div class="form-group" :class="{'has-error': errors['title']}">
      <label for="title" class="col-sm-2 control-label">Título</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="title" v-model="data.title" required />
        <div class="help-block" v-for="e in errors['title']">{{e}}</div>
      </div>
    </div>
    <div class="form-group" :class="{'has-error': errors['description']}">
      <label for="description" class="col-sm-2 control-label">Descripción</label>
      <div class="col-sm-10">
        <editor id="description" v-model="data.description" ></editor>
        <div class="help-block" v-for="e in errors['description']">{{e}}</div>
      </div>
    </div>
    <div class="form-group" :class="{'has-error': errors['alt_text']}">
      <label for="alt_text" class="col-sm-2 control-label">Texto Alternativo</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="alt_text" v-model="data.alt_text" />
        <div class="help-block" v-for="e in errors['alt_text']">{{e}}</div>
      </div>
    </div>
    <div class="form-group" :class="{'has-error': errors['image']}">
      <label for="image" class="col-sm-2 control-label">Imagen</label>
      <div class="col-sm-10">
        <image-select id="image" v-model="data.image" :images="this.images"></image-select>
        <div class="help-block" v-for="e in errors['image']">{{e}}</div>
      </div>
    </div>
    <div class="form-group" :class="{'has-error': errors['tramites']}">
      <label for="tramites" class="col-sm-2 control-label">Trámites</label>
      <div class="col-sm-10">
        <multiselect
          v-model="data.tramites"
          tag-placeholder="Agregar un Nuevo Trámite"
          placeholder="Busque y agregue un Nuevo Trámite"
          selectedLabel="Agregado"
          selectLabel="Presiones enter o click para agregar"
          deselectLabel="Presiones enter o click para eliminar"
          label="title"
          track-by="master_id"
          :options="options"
          :multiple="true"
          :taggable="true"
          @tag="addTag"
        ></multiselect>
        <div class="help-block" v-for="e in errors['tramites']">{{e}}</div>
        <!-- <pre class="language-json"><code>{{ data.tramites  }}</code></pre> -->
      </div>
    </div>
     <div v-if="moreStage" class="form-group">
      <label for class="col-sm-2 control-label">Agregar Nuevo Etapa</label>
      <div class="col-sm-10">
          <a href="#" @click.prevent="addStage" >
            <i class="material-icons">add_circle</i>
          </a>
      </div>
    </div>
    <div  v-if="attrStage" class="attr-attrStage">
      <div  class="form-group" :class="{'has-error': errors['nameStage']}">
        <label for="" class="col-sm-2 control-label">Nombre</label>
          <div class="col-sm-10">
            <input type="text" class="form-control " id='nameStage' v-model="nameStage" >
            <div class="help-block" v-for="e in errors['nameStage']">{{e}}</div>
          </div>
      </div>
      <div class="form-group" :class="{'has-error': errors['description']}">
        <label for="" class="col-sm-2 control-label">Descripción</label>
          <div class="col-sm-10">
            <editor v-model="descriptionView" ></editor>
            <div class="help-block" v-for="e in errors['description']">{{e}}</div>
          </div>
      </div>
       <div class="form-group" >
          <label for="active" class="col-sm-2 control-label">Seo</label>
          <div class="col-sm-10">
            <div class="form-group" >
                <label for=""  class="col-sm-2 control-label">URL indexada en sitemap</label>
                <div class="col-sm-10" v-if="this.existsitemap === false">
                        <p class="control-label" style="text-align: left">No.</p>
                </div>
                <div class="col-sm-10" v-else-if="'message' in this.existsitemap">
                        <p class="control-label" style="text-align: left">{{ this.existsitemap.message }} </p>
                </div>
                <div class="col-sm-10" v-else-if="'createdAt' in this.existsitemap">
                        <p class="control-label" style="text-align: left">Si, actualizado el {{ this.existsitemap.createdAt }} </p>
                </div>
            </div>
            <div class="form-group" :class="{ 'has-error': errors['custom_title'] }">
                <label for=""  class="col-sm-2 control-label">Page title</label>
                <div class="col-sm-10">
                    <el-popover placement="bottom" title="Page title" width="200" trigger="click" content="Título con que aparecera en la búsquedas como Google " >
                        <el-button slot="reference">?</el-button>
                    </el-popover>
                </div>
                <div class="col-sm-offset-2 col-sm-10">
                    <textarea type="text"  v-model="customtitleStage" class="form-control" name="customtitleStage" id="customtitleStage" style="height: 100px;"  ></textarea>
                    <div class="help-block" v-for="e in errors['customtitleStage']">{{ e }}</div>
                </div>
            </div>
            <div class="form-group">
                <label for=""  class="col-sm-2 control-label" :class="{ 'has-error': errors['custom_meta'] }">Meta description</label>
                <div class="col-sm-10">
                    <el-popover placement="bottom" title="Meta description" width="200" trigger="click" content="Descripción o resumen del contenido de la página" >
                        <el-button slot="reference">?</el-button>
                    </el-popover>
                </div>
                <div class="col-sm-offset-2 col-sm-10">
                  <textarea type="text"  v-model="custommetaStage" class="form-control" name="custommetaStage" id="custommetaStage" style="height: 150px;"  ></textarea>
                  <div class="help-block" v-for="e in errors['custommetaStage']">{{ e }}</div>
                    <br>
                </div>
            </div>

            <div class="form-group">
                <label for=""  class="col-sm-2 control-label">Keywords</label>
                <div class="col-sm-10">
                    <div class="chip-container" >
                        <div class="chip" v-for="(chip, i) of chipsStages" :key="chip.label">
                            {{ chip }}
                            <i class="material-icons" @click="deleteChipStage(i)">clear</i>
                        </div>
                        <input ref="keywrdStage"    v-model="currentInputStage"  @keyup="evalKeyStage"  @keydown.delete="backspaceDeleteStage"  />
                    </div>
                    <div class="help-block">Ingrese keywords separados por comas (,) .</div>
                    <div class="help-block" v-for="e in errors['keywordsStage']">{{ e }}</div>
                </div>
            </div>
          </div>
        </div>
      <div class="form-group">
        <label for="" class="col-sm-2 control-label">Previsualización</label>
          <div class="col-sm-10 life-stages ">
            <div class="row">
              <div v-if="nameStage.length > 0 || descriptionView.length >0 " class="col-sm-6 col-xs-6">
                <a class="stage-block"  >
                  <div class="block-header">
                    <span class="capital">{{letterOrder(pos)}}</span>
                    <h4>{{nameStage}}</h4>
                    <div class="iconHeader-bg">&nbsp;</div>
                  </div>
                  <div class="block-body">
                    <span style="padding:0px" v-html="description"></span>
                    <div class="line-bottom"></div>
                  </div>
                </a>
                </div>
             </div>
          </div>
        </div>
      <div class="form-group">
          <div class="col-sm-offset-2 col-sm-10 ">
            <a class="btn btn-default" href="#"  @click.prevent="cancelStage" role="button">Cancelar</a>
            <a class="btn btn-primary"  href="#"  @click.prevent="saveStage" role="button">Agregar</a>
          </div>
      </div>
    </div>
    <div class="form-group">
      <label for class="col-sm-2 control-label">Etapas</label>
      <div class="col-sm-10">
        <table class="table">
          <thead>
            <tr>
              <th>Orden</th>
              <th>Nombre</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(stage,index) in this.data.stages">
              <td>
                {{letterOrder(stage.order)}}
              </td>
              <td>
                {{stage.name}}
              </td>
              <td>
                <a href="#"  @click.prevent="up(index)" title="Subir"><i class="material-icons">arrow_upward</i></a>
                <a href="#"  @click.prevent="down(index)" title="Bajar"><i class="material-icons">arrow_downward</i></a>
                <a v-if="stage.id != undefined " :href="'backend/hito-vida/' + hitovida.id +'/etapa/'+ stage.id +'/pasos'"><i class="material-icons">visibility</i></a>
                <a href="#" @click.prevent="editStage(index)"  title="Editar"><i class="material-icons">edit</i></a>
                <a href="#" @click.prevent="deleteStage(index)" title="Borrar"><i class="material-icons">delete</i></a>
              </td>
            </tr>
          </tbody>
        </table>
        <em v-if="showMsgStage || moreStage">Una vez registradas las etapas se le podra agregar sus pasos.</em>
      </div>
    </div>
    <div class="form-group" style="border-color: #EAF0F7;border-style: dashed;">
      <label for="active" class="col-sm-2 control-label">Seo</label>
      <div class="col-sm-10">
        <div class="form-group" >
            <label for=""  class="col-sm-2 control-label">URL indexada en sitemap</label>
            <div class="col-sm-10" v-if="this.existsitemap === false">
                    <p class="control-label" style="text-align: left">No.</p>
            </div>
            <div class="col-sm-10" v-else-if="'message' in this.existsitemap">
                    <p class="control-label" style="text-align: left">{{ this.existsitemap.message }} </p>
            </div>
            <div class="col-sm-10" v-else-if="'createdAt' in this.existsitemap">
                    <p class="control-label" style="text-align: left">Si, actualizado el {{ this.existsitemap.createdAt }} </p>
            </div>
        </div>
        <div class="form-group" :class="{ 'has-error': errors['custom_title'] }">
            <label for=""  class="col-sm-2 control-label">Page title</label>
            <div class="col-sm-10">
                <el-popover placement="bottom" title="Page title" width="200" trigger="click" content="Título con que aparecera en la búsquedas como Google " >
                    <el-button slot="reference">?</el-button>
                </el-popover>
            </div>
            <div class="col-sm-offset-2 col-sm-10">
                <textarea type="text"  v-model="data.custom_title" class="form-control" name="custom-title" id="custom-page-title" style="height: 100px;"  ></textarea>
                <div class="help-block" v-for="e in errors['custom_title']">{{ e }}</div>
            </div>
        </div>
        <div class="form-group">
            <label for=""  class="col-sm-2 control-label" :class="{ 'has-error': errors['custom_meta'] }">Meta description</label>
            <div class="col-sm-10">
                <el-popover placement="bottom" title="Meta description" width="200" trigger="click" content="Descripción o resumen del contenido de la página" >
                    <el-button slot="reference">?</el-button>
                </el-popover>
            </div>
            <div class="col-sm-offset-2 col-sm-10">
              <textarea type="text"  v-model="data.custom_meta" class="form-control" name="customMetaText" id="customMetaText" style="height: 150px;"  ></textarea>
              <div class="help-block" v-for="e in errors['custom_meta']">{{ e }}</div>
                <br>
            </div>
        </div>

         <div class="form-group">
            <label for=""  class="col-sm-2 control-label">Keywords</label>
            <div class="col-sm-10">
                <div class="chip-container" >
                    <div class="chip" v-for="(chip, i) of chips" :key="chip.label">
                        {{ chip }}
                        <i class="material-icons" @click="deleteChip(i)">clear</i>
                    </div>
                    <input ref="keywrd"    v-model="currentInput"  @keyup="evalKey"  @keydown.delete="backspaceDelete"  />
                </div>
                <div class="help-block">Ingrese keywords separados por comas (,) .</div>
                <div class="help-block" v-for="e in errors['keywords']">{{ e }}</div>
            </div>
        </div>
      </div>
    </div>
    <div class="form-group"  :class="{'has-error': errors['active']}" >
      <label for="active" class="col-sm-2 control-label">¿Permitir explorar?</label>
      <div class="col-sm-10">
          <el-switch v-model="data.open" on-text="SI" off-text="NO"></el-switch>
      </div>
    </div>
    <div class="form-group"  :class="{'has-error': errors['active']}" >
      <label for="active" class="col-sm-2 control-label">¿Activo?</label>
      <div class="col-sm-10">
          <el-switch v-model="data.active" on-text="SI" off-text="NO"></el-switch>
      </div>
    </div>
    <div v-if="data.title.length > 0" class="form-group">
      <label class="col-sm-2 control-label">Previsualización home</label>
      <div class="col-sm-offset-2 col-sm-10">
        <div class="row">
          <div class=" col-xs-6">
            <a class="stage-block" href="javascript:void(0);" :alt="data.alt_text" :title="data.title">
              <div class="block-header">
                <img v-if="data.image" class="icon" :src="'images/'+data.image">
                <h4 style="min-height:70px">{{data.title}}</h4>
                <div v-if="data.image" class="iconHeader-bg">&nbsp;</div>
              </div>
              <div class="block-body">
                 <span style="padding:0px" v-html="data.description"></span> 
                 <div class="line-bottom"></div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="data.title.length > 0" class="form-group">
       <label class="col-sm-2 control-label">Previsualización Hito</label>
        <div class="col-sm-offset-2 col-sm-10  life-stages ">
          <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="iconHeader-bg page-title">
                   <img v-if="data.image" class="icon" :src="'images/'+data.image">
                  <h2>{{data.title}}</h2>
                </div>
            </div>
          </div>
          <div class="row">
            <div v-for="(stage,index) in data.stages" class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
              <a class="stage-block" href="#">
                <div class="block-header">
                  <span class="capital">{{letterOrder(stage.order)}}</span>
                  <h4>{{stage.name}}</h4>
                  <div class="iconHeader-bg">&nbsp;</div>
                </div>
                <div class="block-body">
                  <span style="padding:0px" v-html="stage.description"></span> 
                  <div class="line-bottom"></div>
                </div>
              </a>
            </div>
          </div>
        </div>
    </div>
    <div class="form-group">
      <div class="col-sm-offset-2 col-sm-10">
        <a class="btn btn-default" href="backend/hito-vida">Cancelar</a>
        <button type="submit" class="btn btn-primary">Guardar</button>
      </div>
    </div>
  </form>
</template>
<style lang="scss" scoped>
  .el-select{
    display: block;
  }  

  .attr-attrStage{
    background: #F7F7F7;
    border: 1px solid #F7F7F7;
    border-radius: 4px;
    display: block;
    padding-top: 14px;
    padding-right: 14px;
    margin-bottom: 7px;
  }
</style>
<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import Multiselect from "vue-multiselect";
import { Message } from "element-ui";
import ImageSelect from "./ImageSelect.vue";
import Editor from './Editor.vue';


// register globally
// Vue.component("multiselect", Multiselect);

export default {
  components: { Multiselect, ImageSelect ,Editor},
  data: function() {
    const hitovida = _.cloneDeep(this.hitovida);
    var letterorder ='';
    
    hitovida.tramites = Object.values(this.hitovida.tramites);
    // if(Object.values(this.hitovida.pages))
    //   hitovida.tramites = Object.values(this.hitovida.pages);

    if(Object.values(this.hitovida.stages )){
      hitovida.stages = Object.values(this.hitovida.stages ) ;
    }

    return {
      data: hitovida,
      attrStage:false,
      nameStage:'',
      descriptionView:'',
      description:'',
      pos:0,
      moreStage:  hitovida.stages.length <3 ? true: false,
      chips: [],
      currentInput: "",
      set: {
        type: Boolean,
        default: true
      },
      addkeyword:false,
      customtitleStage:'',
      custommetaStage:'',
      keywordsStage:'',
      chipsStages:[],
      currentInputStage:"",
      addkeywordStage:false,
      showMsgStage:false,
      errors: {}
    };
  },
  watch:{
    descriptionView:function(text){
            var finalText = '';

            finalText = text.replace(/<ul>/gi,'<ul class="stage-list">');
            finalText = finalText.replace(/<li>/gi,'<li><span>');
            finalText = finalText.replace(/<\/li>/gi,'</span></li>');
            this.description = finalText;
    } 
  },
  props: ["hitovida", "admin", "options", "edit", "images",'existsitemap'],  
  created:function() {
    var keywords = this.data.keywords.split(",");
    var filtered = keywords.filter(function(e) {
      return e;
      });
    filtered = filtered.map(function(s) {
        return String.prototype.trim.apply(s);
    });
    this.chips = filtered;
    this.data.keywords = this.chips.join(", ");

  },
  methods: {
    addTag: function(newTag) {
      const tag = {
        title: newTag.title,
        master_id: newTag.master_id //newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.tramites.push(tag);
    },
    addStage : function(){
      this.attrStage =true;
      this.pos = -1;
    },
    editStage:function(index){
      this.attrStage = true;
      this.pos = this.data.stages[index].order;
      this.nameStage = this.data.stages[index].name.trim();
      this.description =this.data.stages[index].description;
      this.descriptionView = this.data.stages[index].description;
      this.customtitleStage = this.data.stages[index].custom_title;
      this.custommetaStage = this.data.stages[index].custom_meta;
      this.moreStage = false;

      var keywords = this.data.stages[index].keywords.split(",");
      var filtered = keywords.filter(function(e) {
                      return e;
                      });
      filtered = filtered.map(function(s) {
                      return String.prototype.trim.apply(s);
                  });
      this.chipsStages = filtered;
      this.keywordsStage = this.chipsStages.join(", ");

      // this.currentInputStage = this.data.stages[index].keywords;
    },
    deleteStage:function(index){
      var self = this;

      self.$confirm('¿Está seguro de eliminar la etapa?','Atención',{
        confirmButtonText:'Eliminar',
        cancelButtonText: 'Cancelar',
        type:'warning'
      }).then(() => {
        this.data.stages.splice(index,1);
        this.moreStage = true;
      }).catch();

    },
    cancelStage:function(){
        this.attrStage = false;
        this.nameStage = '';
        this.description = '';
        this.descriptionView ='';
        this.customtitleStage = '';
        this.custommetaStage = '';
        this.keywordsStage ='';
        this.moreStage = true;
    },
    saveStage:function(){
      var self = this;
      this.errors = {};

      if(!self.nameStage || self.nameStage.length == 0 )
        self.errors['nameStage']= ['Debe ingresar el nombre de la etapa'];
            
      if(!self.description || self.description.length == 0)
        self.errors['description']=['Debe ingresar la descripción de la etapa'];

      if(_.size(self.errors) >0){
        self.$message.error("Revise los errores en el formulario para continuar.");
        return false;
      }else{
        var stages =[];
        var stage = {};

        if(self.data.stages.length > 0){
          stages = self.data.stages;
        }
      
        if(self.pos > 0 ){
            stage = stages[self.pos-1] ;
        }
        stage.name = self.nameStage ;
        stage.description=self.description;
        stage.order= self.pos <0 ? this.data.stages.length +1 : self.pos;
        stage.custom_title = self.customtitleStage ;
        stage.custom_meta= self.custommetaStage;
        stage.keywords = self.keywordsStage;

        if(self.pos < 0 )
          stages.push(stage);
        else
          stages[self.pos-1] = stage;

        self.data.stages = stages;
        self.attrStage = false;
        self.moreStage = this.data.stages.length <3 ? true:false ;
        self.nameStage = '';
        self.description = '';
        self.descriptionView ='';
        this.customtitleStage = '';
        this.custommetaStage = '';
        self.keywordsStage ='';
        self.chipsStages =[];
      }


    },
    submit: function() {
      var self = this;
      var errores = {};
      var keywordInput = this.currentInput.trim();
      var keywordInputStage = this.currentInputStage.trim();

      if (keywordInput.length > 0 || keywordInputStage.length >0) {
        if(keywordInput.length > 0)
          this.saveChip();
        else
          this.saveChipStage();
      }
      else
      {
        if (!self.data.title || self.data.title.length == 0) {
          errores["title"] = ["Debe ingresar el Título del nuevo Hito de Vida"];
        }
        
        if (!self.data.description || self.data.description.length == 0) {
          errores["description"] = ["Debe ingresar la descripción del nuevo Hito de Vida"];
        }
  
        if (!self.data.tramites || self.data.tramites.length == 0) {
          errores["tramites"] = ["Seleccione al menos un Trámite para el nuevo Hito de Vida"];
        }
  
        if (!self.data.image || self.data.image.length == 0) {
          errores["image"] = ["Debe seleccionar una imagen"];
        }

        if(!self.data.custom_title || self.data.custom_title.length == 0){
          errores['custom_title'] = ['Debe ingresar custom page title'];
        }
         
        if(!self.data.custom_meta || self.data.custom_meta.length == 0){
          errores['custom_meta'] = ['Debe ingresar custom meta description']
        } 
        if (_.size(errores) > 0) {
          self.errors = errores;
          self.$message.error(
            "Revise los errores en el formulario para continuar."
          );
          return false;
        }
  
        axios({
          url: this.edit
            ? "backend/hito-vida/" + this.data.id
            : "backend/hito-vida",
          method: this.edit ? "PUT" : "POST",
          data: this.data
        })
        .then(response => {
          window.location.replace(response.data.redirect);
        })
        .catch(error => {
          this.errors = error.response.data.errors;
        });

      }
    },
    letterOrder:function(order){
      
      this.isRegistered(order);
      order = order < 0 ? this.data.stages.length +1 : order ;

      return String.fromCharCode(64 + order);
    },
    isRegistered(order){
      // console.log(this.data.stages[order-1]);      
      if(this.data.stages[order-1] === undefined) 
        this.showMsgStage = true;
    },
    up: function(from){
      if(from == 0)
        return;

      var to = from - 1;
      var pos = 1 ;

      this.data.stages.splice(to, 0, this.data.stages.splice(from, 1)[0]);

      this.data.stages.forEach(c => {
        c.order = pos;
        pos++;
      });

    },
    down: function(from){
      var to = from + 1;
      var pos = 1 ;
      
      this.data.stages.splice(to, 0, this.data.stages.splice(from, 1)[0]);
      this.data.stages.forEach(c => {
                                      c.order = pos;
                                      pos++;
                                  });
    },
    setFocus() {
      this.$refs.keywrd.focus();
    },
    setFocusStage() {
      this.$refs.keywrdStage.focus();
    },
    saveChip() {
      const { chips, currentInput, set } = this;
      
      ((set && chips.indexOf(currentInput) === -1) || !set) && chips.push(currentInput);
      this.currentInput = "";
      this.updateData();
    },
    saveChipStage() {
      const { chipsStages, currentInputStage, set } = this;
      
      ((set && chipsStages.indexOf(currentInputStage) === -1) || !set) && chipsStages.push(currentInputStage);
      this.currentInputStage = "";
      this.updateDataStage();
    },
    deleteChip(index) {
      this.chips.splice(index, 1);
      this.updateData();
    },
    deleteChipStage(index) {
      this.chipsStages.splice(index, 1);
      this.updateDataStage();
    },
    evalKey: function(event) {
      if (event.key === ",") {
        this.currentInput = this.currentInput.split(",").join("");
        
        if (this.currentInput.length) {
          this.saveChip();
          this.addkeyword = true;
        }
      }
    },
    evalKeyStage: function(event) {
      if (event.key === ",") {
        this.currentInputStage = this.currentInputStage.split(",").join("");
        
        if (this.currentInputStage.length) {
          this.saveChipStage();
          this.addkeywordStage = true;
        }
      }
    },
    backspaceDelete({ which }) {
      which == 8 &&
      this.currentInput === "" &&
      this.chips.splice(this.chips.length - 1);
      this.updateData();
    },
    backspaceDeleteStage({ which }) {
      which == 8 &&
      this.currentInputStage === "" &&
      this.chipsStages.splice(this.chipsStages.length - 1);
      this.updateDataStage();
    },
    updateData() {
      this.data.keywords = this.chips.join(", ");
    },
    updateDataStage() {
      this.keywordsStage = this.chipsStages.join(", ");

    } 
  }
};
</script>
